import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

/**
 * @private
 * @description adds location attributes based on what was passed in
 * @param {object} parameters - named parameters
 * @property {number} latitude - used for searching for stores and inventory availability
 * @property {number} longitude - used for searching for stores and inventory availability
 * @property {string} postalCode - used along with type for search to search within range of a postalCode
 * @property {FulfillmentOfferingItemLocationPostalAddress} postalAddress - used for shipping, passed in as input from user or from user data
 * @returns {FulfillmentOfferingItemLocation} an object with properties expected in item.location
 */
export default function addLocationAttributes(_ref) {
  var latitude = _ref.latitude,
      longitude = _ref.longitude,
      postalCode = _ref.postalCode,
      postalAddress = _ref.postalAddress,
      rest = _objectWithoutProperties(_ref, ["latitude", "longitude", "postalCode", "postalAddress"]);

  if (latitude && longitude) {
    return _objectSpread(_objectSpread({}, rest), {}, {
      coordinates: {
        latitude: latitude,
        longitude: longitude
      }
    });
  }

  if (postalAddress) {
    return _objectSpread(_objectSpread({}, rest), {}, {
      postalAddress: postalAddress
    });
  }

  return postalCode ? _objectSpread(_objectSpread({}, rest), {}, {
    postalCode: postalCode
  }) : null;
}